import { render, staticRenderFns } from "./faqcategory.vue?vue&type=template&id=6ac6e603&"
import script from "./faqcategory.vue?vue&type=script&lang=js&"
export * from "./faqcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports